// @flow

import { CONFERENCE_JOINED } from '../../../react/features/base/conference/actionTypes';
import { JitsiConferenceEvents } from '../../../react/features/base/lib-jitsi-meet';
import { setAudioMuted } from '../../../react/features/base/media/actions';
import { MEDIA_TYPE } from '../../../react/features/base/media/constants';
import { raiseHand } from '../../../react/features/base/participants/actions';
import { getLocalParticipant } from '../../../react/features/base/participants/functions';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { playSound } from '../../../react/features/base/sounds/actions';
import Notification from '../../../react/features/notifications/components/web/Notification';
import { isForceMuted } from '../../../react/features/participants-pane/functions';
import { TALK_WHILE_MUTED_SOUND_ID } from '../../../react/features/talk-while-muted/constants';
import { iAmVisitor } from '../../../react/features/visitors/functions';
import { hideCustomNotification, showCustomNotification } from '../../components/notifications/actions';
import {
    TALK_WHILE_MUTED_HIDE_TIMEOUT
} from '../../wizyconf/constants';


MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    const { dispatch, getState } = store;
    const { conference } = action;

    switch (action.type) {
    case CONFERENCE_JOINED: {
        conference.on(
            JitsiConferenceEvents.TRACK_MUTE_CHANGED,
            track => {
                const { customNotification } = getState()['wildix/features/notifications'];

                if (customNotification && track.isAudioTrack() && track.isLocal() && !track.isMuted()) {
                    dispatch(hideCustomNotification());
                }
            });
        conference.on(
            JitsiConferenceEvents.TALK_WHILE_MUTED, () => {
                let timeout;
                const state = getState();
                const local = getLocalParticipant(state);

                if (iAmVisitor(state)) {
                    return;
                }

                if (typeof APP !== 'undefined' && APP.wildix.wizy) {
                    timeout = TALK_WHILE_MUTED_HIDE_TIMEOUT;
                }
                const forceMuted = isForceMuted(local, MEDIA_TYPE.AUDIO, state);

                dispatch(showCustomNotification({
                    titleKey: 'toolbar.talkWhileMutedPopup',
                    customActionNameKey: [ forceMuted ? 'notify.raiseHandAction' : 'notify.unmute' ],
                    customActionHandler: [ () => dispatch(forceMuted ? raiseHand(true) : setAudioMuted(false)) ]
                }, Notification, 'talk-while-muted-flag-group', timeout));

                const { soundsTalkWhileMuted } = getState()['features/base/settings'];

                if (soundsTalkWhileMuted) {
                    dispatch(playSound(TALK_WHILE_MUTED_SOUND_ID));
                }
            });
        break;
    }
    }

    return result;
});
